var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 165,
    viewBox: "0 0 124 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    width: 124,
    height: 165,
    rx: 5,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 63,
    cy: 158,
    r: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 108,
    height: 143
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 8,
    y: 8,
    width: 108,
    height: 143,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 13,
    width: 90,
    height: 68
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 18,
    y: 13,
    width: 90,
    height: 67.9702,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    width: 76.407,
    height: 76.407,
    rx: 1,
    transform: "matrix(0.704649 -0.709556 0.704649 0.709556 -17.5203 94.4032)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    width: 76.407,
    height: 76.407,
    rx: 1,
    transform: "matrix(0.704648 -0.709557 0.704648 0.709557 27 85.3405)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 18.5,
    y: 13.5,
    width: 89,
    height: 66.9702,
    rx: 0.5,
    stroke: "#282C34"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 18,
    y: 78.9403,
    width: 90,
    height: 3.08955,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 18,
    y: 111,
    width: 22,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 18,
    y: 111,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_2",
    x: 42,
    y: 111,
    width: 14,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_2",
    x: 42,
    y: 111,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_3",
    x: 58,
    y: 111,
    width: 5,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_3",
    x: 58,
    y: 111,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_4",
    x: 65,
    y: 111,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_4",
    x: 65,
    y: 111,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_5",
    x: 84,
    y: 111,
    width: 20,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_5",
    x: 84,
    y: 111,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_6",
    x: 18,
    y: 105,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_6",
    x: 18,
    y: 105,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_7",
    x: 45,
    y: 105,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_7",
    x: 45,
    y: 105,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_8",
    x: 53,
    y: 105,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_8",
    x: 53,
    y: 105,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_9",
    x: 66,
    y: 105,
    width: 30,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_9",
    x: 66,
    y: 105,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_10",
    x: 18,
    y: 99,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_10",
    x: 18,
    y: 99,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_11",
    x: 38,
    y: 99,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_11",
    x: 38,
    y: 99,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_12",
    x: 49,
    y: 99,
    width: 24,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_12",
    x: 49,
    y: 99,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_13",
    x: 75,
    y: 99,
    width: 33,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_13",
    x: 75,
    y: 99,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_14",
    x: 18,
    y: 117,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_14",
    x: 18,
    y: 117,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_15",
    x: 26,
    y: 117,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_15",
    x: 26,
    y: 117,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_16",
    x: 43,
    y: 117,
    width: 29,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_16",
    x: 43,
    y: 117,
    width: 29,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_17",
    x: 74,
    y: 117,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_17",
    x: 74,
    y: 117,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_18",
    x: 18,
    y: 123,
    width: 20,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_18",
    x: 18,
    y: 123,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_19",
    x: 40,
    y: 123,
    width: 23,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_19",
    x: 40,
    y: 123,
    width: 23,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_20",
    x: 65,
    y: 123,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_20",
    x: 65,
    y: 123,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_21",
    x: 83,
    y: 123,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_21",
    x: 83,
    y: 123,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_22",
    x: 18,
    y: 129,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_22",
    x: 18,
    y: 129,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_23",
    x: 24,
    y: 129,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_23",
    x: 24,
    y: 129,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 18,
    y: 142,
    width: 30,
    height: 8,
    rx: 2,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 18,
    y: 142,
    width: 30,
    height: 7,
    rx: 2,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HeadLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_24",
    x: 18,
    y: 89,
    width: 15,
    height: 7,
    rx: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_24",
    x: 18,
    y: 89,
    width: 15,
    height: 6,
    rx: 3,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HeadLine_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_25",
    x: 35,
    y: 89,
    width: 28,
    height: 7,
    rx: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_25",
    x: 35,
    y: 89,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#282C34"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.97fe932b7b08017a14e468d5fb1f1425.svg";
export { ForwardRef as ReactComponent };